import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center bg-zinc-100">
        <div className="font-mono text-xs uppercase tracking-widest text-zinc-500">Loading session…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-10">
        <h2 className="font-display text-2xl font-bold mb-2">Access denied</h2>
        <p className="text-sm text-zinc-600">Your role <code className="font-mono">{user.role}</code> does not have access to this page.</p>
      </div>
    );
  }
  return children;
}
